import { render, staticRenderFns } from "./PageEvent.vue?vue&type=template&id=74183422&"
import script from "./PageEvent.vue?vue&type=script&lang=js&"
export * from "./PageEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74183422')) {
      api.createRecord('74183422', component.options)
    } else {
      api.reload('74183422', component.options)
    }
    module.hot.accept("./PageEvent.vue?vue&type=template&id=74183422&", function () {
      api.rerender('74183422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event/PageEvent.vue"
export default component.exports